<template>
  <div class="plate" v-if="plate">
    <!--   title     -->

    <div class="">
      This is
      <span class="font-weight-bold">
        {{ agent.fname }} {{ agent.lname }},
      </span>
      Senior agent at Blueberry. I'll help on a recorded line.
    </div>

    <!--    life insurance    -->

    <div class="mb-4">Do you currently have Life Insurance?</div>

    <v-radio-group
      v-model="plate.isLifeInsurance"
      class="radio-questions"
      column
    >
      <v-radio label="Yes" :value="true" />
      <v-radio label="No" :value="false" />
    </v-radio-group>

    <!--    properties    -->

    <div class="my-4">
      You're going to be HAPPY!
      <span class="font-weight-bold"> {{ lead.firstname }}, </span>
      you said your date of birth is
      <span class="font-weight-bold">
        {{ format(new Date(lead.birth_date), 'MM-dd-yyyy') }}
      </span>
      and your height is
      <span class="font-weight-bold">
        {{ lead.height }}
      </span>
      weight
      <span class="font-weight-bold"> {{ lead.weight }}. </span>
      Is that correct?

      <v-radio-group
        v-model="plate.isPropertiesCorrect"
        class="radio-questions"
        column
      >
        <v-radio label="Yes" :value="true" />
        <v-radio label="No" :value="false" />
      </v-radio-group>
    </div>

    <div class="my-4">
      <div class="mb-2">It's good you reached us, Because Blueberry:</div>

      <div
        v-for="benefit in benefits"
        :key="benefit.value"
        class="questions-indent"
      >
        <v-checkbox
          :error="$v.plate.benefits.$error"
          v-model="plate.benefits"
          :value="benefit.value"
          :label="benefit.body"
        />
      </div>
    </div>

    <!--    footer    -->

    <div class="my-4">
      That being said,
      <span class="font-weight-bold">
        {{ agent.fname }} {{ agent.lname }}
      </span>

      Senior agent and I'm here to guide and support you. I have a ton of
      knowledge and experience. We just want to make sure that is the event of
      something happening, YOUR family is financial protected. And
      <span class="font-weight-bold"> {{ lead.firstname }}, </span> I promise to
      make this quick and simple. Sound fair?
    </div>

    <PlateFooter
      :onSubmit="onSubmit"
      :isLoading="isLoading"
      firstStep
      :errors="$v.$error"
    />
  </div>
</template>

<script>
import { format } from 'date-fns';
import PlateFooter from '@/components/lead/plates/PlateFooter';
import { PlatesSteps } from '@/common/variables';

export default {
  name: 'IntroPlate',
  components: { PlateFooter },
  props: {
    agent: {
      type: Object,
    },
    lead: {
      type: Object,
    },
  },
  data: () => ({
    plate: null,
    benefits: [
      {
        value: 'benefits_1',
        body: 'Is one of the largest Insurance services in America, we protect thousands of families each month.',
        isChecked: false,
      },
      {
        value: 'benefits_2',
        body: 'We use advance technology to shop the leading companies, finding you the best solution tailored to your Needs.',
        isChecked: false,
      },
      {
        value: 'benefits_3',
        body: 'And our #1 core value is to, BE THE CHANGE YOU WANT TO SEE IN THE WORLD.',
        isChecked: false,
      },
    ],
    isLoading: false,
  }),
  methods: {
    onSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) return;

      this.$store.commit('plates/setStep', PlatesSteps.occupation);
      this.$store.dispatch('plates/updatePlate', this.lead);
    },
    format,
  },

  mounted() {
    const { data } = this.$store.getters['plates/dataByStep'](
      PlatesSteps.intro
    );
    this.plate = data;
  },
  validations: {
    plate: {
      benefits: {
        value: function (val) {
          return this.benefits.every((i) => val.includes(i.value));
        },
      },
    },
  },
};
</script>

<style lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.plate {
  font-size: 18px;

  & .v-messages {
    display: none;
  }

  & label.v-label {
    color: black !important;
    flex-grow: 0 !important;
  }

  & label.v-label.error--text {
    color: #ff5252 !important;
  }
}

.questions-indent {
  margin-left: 40px;
}

.radio-questions {
  .v-input--radio-group__input {
    width: auto !important;
  }

  .v-input__slot {
    justify-content: center;
  }
}
</style>